module.exports = __webpack_public_path__ + "static/undraw_programming_2svr-503e1cddcc1a80ebf90b12794d6f90d6.svg";